/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AbstractSchemaBean } from './AbstractSchemaBean';
import {
    AbstractSchemaBeanFromJSON,
    AbstractSchemaBeanFromJSONTyped,
    AbstractSchemaBeanToJSON,
} from './AbstractSchemaBean';

/**
 * 
 * @export
 * @interface UpdateSite
 */
export interface UpdateSite {
    /**
     * 
     * @type {string}
     * @memberof UpdateSite
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSite
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSite
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSite
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateSite interface.
 */
export function instanceOfUpdateSite(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSiteFromJSON(json: any): UpdateSite {
    return UpdateSiteFromJSONTyped(json, false);
}

export function UpdateSiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function UpdateSiteToJSON(value?: UpdateSite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

